import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { BASE_API_URL } from '../Config';
import useAuthentication from '../service/AuthenticationService';

const instance = axios.create({
    timeout: 30_000,
    headers: {
        'Content-Type': 'application/json',
    },
});

export function useLabelsRepository() {
    const authentication = useAuthentication();

    const { isLoading, error, data } = useQuery({
        queryKey: ['labels', authentication.phoneUuid],
        queryFn: async () => {
            const res = await instance.get(BASE_API_URL + '/labels', {
                params: { phoneUuid: authentication.phoneUuid },
                headers: {
                    Authorization: 'Bearer ' + authentication.token,
                },
            });
            return res.data;
        },
        enabled: authentication.isLogged,
        staleTime: 1000 * 60 * 5,
    });

    return { isLoading, error, data };
}
